
import * as yup from 'yup'
import { TYPE_REQUIRED, DATE_INVALID, DATE_IN_PAST, AGE_IN_PAST } from 'constants/errors'
import moment from 'moment'
import { FutureWhen } from 'components/features/future/types'
import { ObjectSchema } from 'yup'
import { schemaString, schemaArrayOfStrings } from 'schemas/baseSchema'

const getMoment = (date: string) => {
  return moment(date, 'YYYY-MM', true)
}

export const createWhenSchema = (birthDate: string) => {
  const currentStartMonth = moment().startOf('month')
  const birthDateStartMonth = moment(birthDate).startOf('month')

  let minAge = moment().diff(birthDate, 'years')
  const monthsToBDay = currentStartMonth.diff(birthDateStartMonth, 'months')
  if (monthsToBDay <= 2) {
    minAge++
  }

  return yup
    .object({
      slug: yup.string().oneOf(['as_soon_as_possible', 'in_certain_years', 'at_age', 'at_month']),
      month: yup
        .string()
        .typeError(TYPE_REQUIRED)
        .test({
          name: 'at_month',
          message: DATE_INVALID,
          test: (value: any) => {
            if (value === undefined) {
              return true
            }
            return getMoment(value).isValid()
          },
        })
        .test({
          name: 'at_month',
          message: DATE_IN_PAST,
          test: (value: any) => {
            if (value === undefined) {
              return true
            }

            const date = getMoment(value)

            const isValid = date.isValid()
            if (!isValid) {
              return false
            }

            const monthDelta = date.startOf('month').diff(currentStartMonth, 'months')

            return monthDelta > 0
          },
        }),
      years: yup.number().typeError(TYPE_REQUIRED),
      age: yup.number().typeError(TYPE_REQUIRED).min(minAge, AGE_IN_PAST),
    }) as ObjectSchema<FutureWhen>
}

export const createCommonSchema = (birthDate: string) => yup.object({
  slug: yup
    .string()
    .required()
    .oneOf([
      'buy_home',
      'sell_home',
      'buy_car',
      'sell_car',
      'large_purchase',
      'vacation',
      'get_married',
      'get_divorced',
      'have_child',
      'retirement',
      'get_degree',
      'get_promoted',
      'lose_job',
      'recession',
      'inherit_money',
      'income_change',
      'new_expense',
    ]),
  name: schemaString,
  is_enabled: yup.boolean(),
  when: createWhenSchema(birthDate),
})

export const schemaRecurrence = yup.string().required(TYPE_REQUIRED).oneOf([
  'one_time',
  'monthly',
  'monthly_as_every_six_months',
  'every_six_months',
  'every_six_months_as_monthly',
  'yearly',
  'every_5_years',
  'every_10_years',
], TYPE_REQUIRED)

export const schemaMaritalStatus = yup.string().required(TYPE_REQUIRED).oneOf([
  'single',
  'married',
], TYPE_REQUIRED)

export const schemaAssetSell = yup.object({
  asset_uid: schemaString,
  is_linked: yup.boolean(),
  debt_uids: schemaArrayOfStrings,
}).transform((values) => {
  let debt_uids = values.debt_uids || []
  if (typeof debt_uids === 'string') {
    debt_uids = [debt_uids]
  }

  return {
    ...values,
    debt_uids,
  }
})
